import React from 'react';

import { Modal, Typography } from 'antd';

import { useUpdateLifecycle } from '../../api/lifecyle/updateLifecycle';

export const CancelLifecyleModal = ({
  timeLineEvent,
  isModalOpen,
  handleOk,
  handleCancel,
  lpUi,
  onRefetch,
}) => {
  const { mutate: updateLifecycle, isPending } = useUpdateLifecycle({
    config: {
      onSuccess: () => {
        onRefetch();
        handleOk();
      },
    },
  });

  const handleConfirmDelete = () => {
    if (timeLineEvent?.id && lpUi) {
      updateLifecycle({
        lifecycleId: timeLineEvent.id,
        lpUi: lpUi,
      });
    }
  };

  return (
    <Modal
      title={`${timeLineEvent?.sub_status ? 'Substatus' : 'Status'} cancellation`}
      closable={{ 'aria-label': 'Custom Close Button' }}
      open={isModalOpen}
      onOk={handleConfirmDelete}
      onCancel={handleCancel}
      centered
      confirmLoading={isPending}
    >
      <Typography.Text>
        Are you sure you want to cancel this{' '}
        {timeLineEvent?.sub_status ? 'substatus' : 'status'}? This action cannot
        be undone.
      </Typography.Text>
    </Modal>
  );
};
